import React, {useContext} from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {UserContext} from '../utils/usercontext';


export const IsLogin = (user) => {
	if(user?.user?.rank<2) return false;
	return true;
}
export const RoutePrivate = () => {
	const {user} = useContext(UserContext);
	if( !IsLogin(user) ) return <Navigate to="/login" />;
	return <Outlet />;
};


export const IsRestricted = (user, page) => {
  if( !user ) return false;
	if( !user.admin ) return false;
	if( user.admin.mod_access && page === "mod" ) return true;
	if( user.admin.admin_access && page === "admin" ) return true;
	return false;
}
export const RouteRestricted = (props) => {
	const {user} = useContext(UserContext);
	if( !IsLogin(user) ) return <Navigate to="/login" />;
	if( !IsRestricted(user, props.page) ) return <Navigate to="/" />;
	return <Outlet />;
};
